/**
 * if a user tries to update a target, and it fails. I provide the reason it fails, what the user tried to do, 
 * and what price the target was at
 * {
	"messageType": "alertNotification",
	"notificationId": 1645468367847,
	"notificationDetails": {"errorType":"INVALID_TACTIC_UPDATE","notificationType":"ERROR","tacticName":"CANDLE_MAGNITUDE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "CANNOT_UPDATE_TARGET",
	"statusDetails": {"cannotAdjustReason":"AUTOMATIC_EXIT","adjustmentType":"EDIT","price":22.0},
	"date": "2022-02-21T13:32:48.798-0500",
	"timestamp": "1645468368798"
}

 * @param {*} statusDetails 
 * @returns object with fields:
 * 1) cannotAdjustReason (ALREADY_IN_USE, DOES_NOT_EXIST,AUTOMATIC_EXIT). The reason the update failed. It can be because either
 * the target is already in use, or the target does not exist (like if you try to remove a target that does not exist), or 
 * it would result in an automatic exit.
 * 2) adjustmentType (ADD,REMOVE,EDIT) what was the action? was the user trying to add a target,remove, or edit it?
 * 3) price: price of the target
 */
export function cannotUpdateTargetParser(statusDetails) {
  const parsedObj = {
    cannotAdjustReason: null,
    adjustmentType: null,
    price: null,
  };
  if (statusDetails) {
    parsedObj.cannotAdjustReason = statusDetails.cannotAdjustReason ?? null;
    parsedObj.adjustmentType = statusDetails.adjustmentType ?? null;
    parsedObj.price = statusDetails.price ?? null;
  }
  return parsedObj;
}
